<template>
  <div class="privacy-wrapper">
    <!-- <pdf ref="pdf" v-for="i in numPages" :key="i" :src="url" :page="i"></pdf> -->
    <div id="container">
      <p style="text-align: center"><strong>天地卫通个人信息保护及隐私政策</strong></p>
      <p>更新日期: 2024年2月19日</p>
      <p>生效日期: 2024年2月19日</p>
      <p>
        广州磐钴智能科技有限公司（以下简称"我们"）非常重视用户的隐私和个人信息保护。您在使用我们的产品或服务时，我们可能会收集和使用您的相关信息。我们希望通过《个人信息保护及隐私政策》（"本隐私政策"）向您说明我们在您使用我们的产品或服务时如何收集、使用、保护这些信息。本隐私政策适用于
        <strong>天地卫通</strong>
        平台。本隐私政策不适用于其他独立第三方向您提供的服务，例如我们平台上的第三方依托我们平台向您提供服务时，您向第三方提供的个人信息不适用于本隐私政策，我们对任何第三方使用由您提供的信息不承担任何责任。
      </p>
      <p>
        【特别提醒】
        <strong>
            在使用我们的产品或服务前，请您务必仔细阅读并透彻理解本隐私政策，在确认充分理解并同意后使用相关产品或服务。如果您不同意本隐私政策任何内容，您应立即停止使用我们平台服务。一旦您开始使用我们的各项产品或服务，即表示您已充分理解并同意本隐私政策。
        </strong>
      </p>
      <p><strong>一、定义</strong></p>
      <p>
        1.1 您：本协议的"您"特指使用
        <strong>天地卫通</strong>
        平台的产品或服务的用户。
      </p>
      <p>
        1.2
        个人信息：本协议的个人信息指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括：<strong>基本信息（包括个人头像、姓名、生日、性别、个人电话号码、邮件、住址）；个人身份信息（包括身份证等）；个人形象，声音和画面；网络身份标识信息（包括系统账号、IP地址、与前述有关的密码、口令）；个人财产信息（交易和消费记录以及账户余额等财产信息）；通讯录；个人上网记录（包括网站浏览记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如设备序列号/IMEI/android
        ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）、WiFi的SSID信息、WiFi的BSSID信息；个人位置信息（包括行程信息、精准定位信息、传感器信息(包括方向传感器、加速度传感器、电磁场传感器)、住宿信息、经纬度等）。</strong>
      </p>
      <p><strong>二、隐私政策</strong></p>
      <p>2.1我们如何收集您的信息</p>
      <p>我们会出于本隐私政策所述的以下目的，<strong>收集和使用您的个人信息：</strong></p>
      <p>2.1.1您向我们提供的信息：</p>
      <p>
        当您在我们平台或产品上注册账户及您在使用我们提供的相关服务时填写或提交的信息，<strong>包括您的姓名、性别、电话号码、地址、兴趣爱好、支付账号及相关附加信息（如您所在的省份和城市、邮政编码等）。</strong>
      </p>
      <p>
        请注意：我们的多项服务，可让您不仅与自己的社交网络分享信息，也与使用该服务的所有用户公开分享您的相关信息，例如，<strong>您在我们平台上传或发布的信息（包括您公开的个人信息等）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据、视频、音频信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据、视频、音频信息）。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存</strong>。
      </p>
      <p>
        因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请和我们取得联系。
      </p>
      <p>2.1.2 在您使用服务过程中收集的信息：</p>
      <p>为了更好的为您提供服务，我们会收集您的相关信息，这类信息包括：</p>
      <p>
        <strong>在您使用我们平台的服务或访问平台网页时，我们会自动接收并记录的您的浏览器、计算机、移动设备的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您的网页记录等数据；如您下载或使用我们或我们关联公司客户端软件，或访问移动网页使用我们平台的服务时，我们可能会读取与您位置和移动设备相关的信息，包括但不限于设备型号、设备识别码、操作系统、分辨率、电信运营商等。</strong>
      </p>
      <p>
        <strong>我们会收集您通过我们平台上传的内容、信息，例如上传或拍摄的文字、共享照片、录音、录像以及该类信息的日期、时间或地点等。</strong>
      </p>
      <p>
        除上述信息外，为了改进服务质量，我们还可能收集您的其他信息，包括且并不限于您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联公司、合作方互动时提供的相关信息。与此同时，为提高您使用相关服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，<strong>我们可能会通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL。</strong>
      </p>
      <p>2.1.3 我们从第三方获得您个人信息的情形：</p>
      <p>
        为了给您提供更好的服务或为了预防互联网犯罪，我们的关联公司、合作伙伴会依据法律的规定或征得您同意的前提下，向我们分享您的个人信息。我们可能<strong>从第三方获取您授权共享的账户信息（头像、昵称）</strong>，并在您同意本隐私政策后将您的第三方账户与您的账户绑定，使您可以通过第三方账户直接登录并使用我们的产品或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。
      </p>
      <p>2.2 我们如何使用信息</p>
      <p>为了提高服务质量，我们可能把您的信息用于下列用途：</p>
      <p>2.2.1 向您提供服务；</p>
      <p>2.2.2 用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</p>
      <!-- <p>
        2.2.3
        向您推荐您可能感兴趣的内容，包括但不限于向您发出产品、服务信息或有关广告，通过系统向您展示个性化的第三方推广信息或者在征得您同意的情况下与我们的合作伙伴共享信息以便他们向您发送有关其产品和服务的信息；
      </p>
      <p>
        2.2.4
        我们可能会将您的个人信息与其他服务信息结合起来，用于为了给您提供更加个性化的服务使用，例如让您拥有更广泛的社交圈的需要而使用、共享或披露；
      </p> -->
      <p>2.2.3 让您参与有关我们产品和服务的调查，促销及抽奖活动；</p>
      <!-- <p>
        2.2.6
        使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示或对您和其他用户作出其他方面的回应，如您对个性化内容不感兴趣，您可选择关闭推送信息，具体可前往我的-隐私设置-个性化选项关闭个性化推荐机制；
      </p> -->
      <p>2.2.4 软件认证或管理软件升级；</p>
      <p>2.2.5 让您参与有关我们产品和服务的调查；</p>
      <p>2.2.6 经您许可的其他用途。</p>
      <p>2.3 我们如何共享信息</p>
      <p>我们对您的信息承担保密义务，不会出售或出租您的任何信息，我们会在下列情况下才将您的信息与第三方共享：</p>
      <p>2.3.1 事先获得您的同意或授权；</p>
      <p>2.3.2 根据法律法规的规定或应行政或司法机关的要求；</p>
      <p>2.3.3 向我们的关联公司分享您的个人信息；</p>
      <p>2.3.4 向可信赖的合作伙伴提供您的个人信息，让他们根据我们的指示和本隐私政策，对这些信息采取保密措施；</p>
      <p>2.3.5 只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议；</p>
      <p>2.3.6 如果您违反了有关法律、法规或者我们平台的相关协议、规则，需要向第三方披露；</p>
      <p>2.3.7 为维护我们及其关联公司或用户的合法权益。</p>
      <p>
        2.3.8
        如果您需要注销您的账号，您可前往我的-头像-注销账号页面提交申请注销，在注销账号之后，我们将停止为您提供全部产品和/或服务，并依据法律法规相关要求通过匿名化等方式处理您的个人信息，或删除与您帐户相关的个人信息但法律法规或监管机构对用户信息存储时间另有规定的除外。
      </p>
      <p>2.3.9 Android 系统权限调用</p>
      <p>1. 位置（大致） 使用场景/目的：<strong>用于完成位置定位，sos救援定位</strong></p>
      <p>收集个人信息的类型：地理位置</p>
      <p>拒绝授权的后果：无法获取用户位置和sos精准救援</p>
      <p>2. 麦克风 使用场景/目的：<strong>用于发送语音</strong></p>
      <p>收集个人信息的类型：音频</p>
      <p>拒绝授权的后果：无法录制音频</p>
      <p>3. 通讯录 使用场景/目的：<strong>用于查找或求救自己通讯录中的好友</strong></p>
      <p>收集个人信息的类型：通讯录信息</p>
      <p>拒绝授权的后果：无法查找、求救自己通讯录好友</p>
      <p>4. 照相设备 使用场景/目的：<strong>用于拍摄、发送救援、完成二维码扫描等需要使用该权限的相关功能</strong></p>
      <p>收集个人信息的类型：图像信息</p>
      <p>拒绝授权的后果：无法写入、读取本地相册</p>
      <p>5. 存储 使用场景/目的：<strong>用于存储用户数据等相关功能</strong></p>
      <p>收集个人信息的类型：存储信息</p>
      <p>拒绝授权的后果：无法使用上述功能</p>
      <p>6. 存储 使用场景/目的：<strong>用于存储用户数据等相关功能</strong></p>
      <p>收集个人信息的类型：存储信息</p>
      <p>拒绝授权的后果：无法使用上述功能</p>
      <p>2.3.10 第三方共享数据清单：</p>
      <p>1. 第三方公司名称：高德软件有限公司</p>
      <p>
        共享信息名称：<strong>设备MAC地址、唯一设备标识码(设备序列号、IDFA、IMEI、OAID、Android_ID、IMSI)、WiFi的SSID信息、WiFi的BSSID信息、位置信息、传感器信息</strong>
      </p>
      <p>使用目的：提供用户位置服务从而获取用户所在地理位置</p>
      <p>使用场景：获取用户所在地理位置进行sos救援</p>
      <p>2. 第三方公司名称：腾讯科技有限公司 com.tencent.bugly(BuglySDK)</p>
      <p>共享信息名称：<strong>设备MAC地址、唯一设备标识码(IDFA、IMEI、OAID、Android_ID、IMSI)、运行中进程信息</strong></p>
      <p>使用目的：提供App稳定性监控，崩溃问题追踪服务</p>
      <p>使用场景：问题追踪</p>
      <p>3. 第三方公司名称：阿里云计算有限公司 com.mobile.auth(阿里云号码认证SDK)</p>
      <p>
        共享信息名称：<strong>设备信息、位置信息、网络信息、SDK认证相关请求结果、手机号码设备信息:
        设备标识符(IMEI、IDFA、Android_ID、MAC、OAID等相关信息)、应用信息(应用前溃信息通知开关状态、软件列表等相关信息)、设备参数及系统信息《设备类型、设备型号、操作系统及硬件相关信息)</strong>
      </p>
      <p>使用目的：用于实现App一键登录和验证用户手机号码与本机流量卡号是否一致的服务</p>
      <p>使用场景：一键登录</p>
      <p>4. 第三方公司名称：中移互联网有限公司</p>
      <p>
        共享信息名称：<strong>网络类型、网络地址、运营商类型本机号码、国际移动用户识别码、sim卡数量识别卡状手机操作系统、硬件厂商</strong>
      </p>
      <p>使用目的：以手机号为基础进行一键式登录</p>
      <p>使用场景：一键登录</p>
      <p><strong>三、Cookie的使用</strong></p>
      <p>
        为使您获得更轻松的访问体验，您访问我们平台网站或使用我们平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash
        Cookie，您的浏览器或关联应用程序提供的其他本地存储（统称"Cookie"）。
      </p>
      <p>
        请您理解，我们的某些服务只能通过使用"Cookie"才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝我们的Cookie，但这一举动在某些情况下可能会影响您安全访问我们平台相关网站和使用我们平台提供的服务。
      </p>
      <p>
        我们的产品和服务上可能会有广告商或其他合作方放置的Cookies和web beacon。这些Cookies和web
        beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方Cookies和web
        beacon收集和使用该等信息，不受本隐私政策约束，而是受相关使用者的隐私政策约束，我们不对第三方的Cookies或web
        beacon承担责任。
      </p>
      <p>
        您可以通过浏览器设置拒绝或管理Cookies或web beacon。但请注意，如果停用Cookies或web
        beacon，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到同样数量的广告，但这些广告与您的相关性会降低。
      </p>
      <p>四、我们如何保护和保存您的个人信息</p>
      <p>
        为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。我们会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄漏、毁损或丢失。
      </p>
      <p>
        您的账户均有安全保护功能，请妥善保管您的账户及密码信息。我们将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在"完善的安全措施"。
      </p>
      <p>
        在使用我们平台服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，<strong>如银行账户信息、联络方式或者邮政地址</strong>。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络我们客服，以便我们采取相应措施。
      </p>
      <p><strong>五、未成年人隐私权特别约定</strong></p>
      <p>我们要求父母或监护人在阅读本隐私政策后指导未满十八岁的未成年人使用我们的服务。</p>
      <p>
        <strong>我们不会在知情的情况下收集未成年人的个人信息。除非所在地法律允许并且监护人同意，未成年人请不要注册账户或发送自己的姓名、住址、电话等个人信息给我们。</strong>如果我们不小心收集到了未成年人的信息，我们在知情后会尽快删除。如果您认为我们可能不当地持有关于未成年人的信息，请联系我们。
      </p>
      <p>六、隐私政策特别条款</p>
      <p>您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</p>
      <p>1、与国家安全和社会公共利益有关的；</p>
      <p>2、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
      <p>3、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>4、所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
      <p>5、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
      <p>6、 违反法律规定或违反我们平台规则导致我们已对您采取必要措施；</p>
      <p>7、根据您的要求签订合同所必需的；</p>
      <p>8、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
      <p>9、为合法的新闻报道所必需的；</p>
      <p>
        10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
      </p>
      <p>11、法律法规规定的其他情形。</p>
      <p><strong>七、隐私政策的变更</strong></p>
      <p>
        我们可能适时修订本隐私政策的条款，而无需提前通知用户，您应当经常查看本隐私政策，该修订构成本隐私政策的一部分。如该等修订造成您在本隐私政策下权利的实质减少，在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本隐私政策的约束。
      </p>
      <p><strong>八、管辖与法律适用</strong></p>
      <p>本隐私政策的成立、生效、履行、解释及纠纷解决，适用中华人民共和国法律。</p>
      <p>
        如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向
        <span class="underline">广州市</span>
        人民法院提起诉讼。
      </p>
      <p><strong>九、如何联系我们</strong></p>
      <p>
        若您对我们的隐私政策或您的个人信息的相关事宜有任何问题、意见或建议，可通过服务电话：
        <span class="underline">020-32379706</span>
        与我们联系，我们邮寄联系方式如下：
      </p>
      <p>广州磐钴智能科技有限公司</p>
      <p>地址：广州市黄埔区瑞和路39号纳金科技园F1座3楼</p>
      <p>邮编：510000</p>
      <p>电子邮箱：info@pgiot.com</p>
      <p>一般情况下，我们将在收到您相关联系信息后三十天内回复。</p>
    </div>
  </div>
</template>

<script>
// import pdf from 'vue-pdf';
export default {
  metaInfo: {
    title: '隐私政策',
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, user-scalable=yes, initial-scale=1.0',
      },
    ],
  },
  data() {
    return {
      // url: '/privacyContent.pdf',
      numPages: null, // pdf 总页数
    };
  },
  // components: {
  //   pdf,
  // },
  methods: {
    // getNumPages() {
    //   let loadingTask = pdf.createLoadingTask(this.url);
    //   loadingTask.promise
    //     .then((pdf) => {
    //       this.numPages = pdf.numPages;
    //     })
    //     .catch((err) => {
    //       console.error('pdf 加载失败', err);
    //     });
    // },
  },
  mounted() {
    // this.getNumPages();
  },
};
</script>

<style lang="scss" scoped>
@import './index.css';
.privacy-wrapper {
  box-sizing: border-box;
  width: 100vw;
  padding: 20px 20px 50px 20px;
}
</style>